(function () {
  'use strict';

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      return r.json();
    });
  }

  function refreshCartUI() {
    document.dispatchEvent(new Event('cart:refresh'));
    document.dispatchEvent(new Event('cart:updated'));
    window.dispatchEvent(new Event('ajaxCart.afterCartLoad'));
  }

  function setBtnLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
  }

  function initBogo() {
    var root = document.querySelector('[data-kk-bogo]');
    if (!root) return;
    var btn = root.querySelector('[data-kk-bogo-add]');
    var variantInput = root.querySelector('[data-kk-bogo-variant]');
    if (!btn || !variantInput) return;

    btn.addEventListener('click', function () {
      var variantId = variantInput.value;
      if (!variantId) return;
      setBtnLoading(btn, true);
      addToCart([{ id: variantId, quantity: 1 }])
        .then(function () { refreshCartUI(); })
        .catch(function () { alert('No se pudo agregar la polera. Intenta nuevamente.'); })
        .finally(function () { setBtnLoading(btn, false); });
    });
  }

  function initBundle() {
    var root = document.querySelector('[data-kk-bundle]');
    if (!root) return;
    var btn = root.querySelector('[data-kk-bundle-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var mainVariant = btn.getAttribute('data-main-variant');
      var items = [];
      if (mainVariant) items.push({ id: mainVariant, quantity: 1 });
      root.querySelectorAll('[data-kk-bundle-variant]').forEach(function (input) {
        if (input.value) items.push({ id: input.value, quantity: 1 });
      });
      if (!items.length) return;

      setBtnLoading(btn, true);
      addToCart(items)
        .then(function () { refreshCartUI(); })
        .catch(function () { alert('No se pudo agregar el combo. Intenta nuevamente.'); })
        .finally(function () { setBtnLoading(btn, false); });
    });
  }

  function initStockScarcity() {
    var root = document.querySelector('[data-kk-stock-scarcity]');
    if (!root) return;
    var dataEl = document.querySelector('[data-kk-stock-data]');
    var text = root.querySelector('[data-kk-stock-text]');
    var fill = root.querySelector('[data-kk-stock-fill]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var threshold = data.threshold || 10;

    function update(variantId) {
      var v = data.variants && data.variants[variantId];
      if (!v || !v.tracked) {
        root.classList.add('hide');
        return;
      }
      var qty = v.quantity || 0;
      if (qty > 0 && qty < threshold) {
        root.classList.remove('hide');
        if (text) text.textContent = '¡Apúrate! Quedan ' + qty + ' unidades';
        if (fill) fill.style.width = Math.min(100, (qty * 100) / threshold) + '%';
      } else {
        root.classList.add('hide');
      }
    }

    onVariantChange(update);
  }

  /* ---------------- Sticky ATC + offset compartido ---------------- */
  // Un único ResizeObserver reutilizado para publicar --konko-sticky-buy-offset.
  var kkStickyResizeObserver = null;

  function setStickyOffset(px) {
    document.documentElement.style.setProperty('--konko-sticky-buy-offset', px + 'px');
  }

  function setStickyVisible(bar, visible) {
    if (bar.classList.contains('is-visible') === visible) return;
    bar.classList.toggle('is-visible', visible);
    setStickyOffset(visible ? bar.offsetHeight : 0);
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-kk-sticky-atc]');
    if (!bar || bar.dataset.kkInit === '1') return;
    bar.dataset.kkInit = '1';

    var sentinel = document.querySelector('form[action="/cart/add"]');

    if (sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // "Ya fue sobrepasado hacia arriba" = su borde inferior quedó
          // por encima del viewport (bottom < 0), no solo "no intersecta".
          var passedAbove = entry.boundingClientRect.bottom < 0;
          setStickyVisible(bar, passedAbove && !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(sentinel);
    } else if (sentinel) {
      // Fallback sin IntersectionObserver: scroll pasivo + rAF, sin cálculos continuos.
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = sentinel.getBoundingClientRect();
          setStickyVisible(bar, rect.bottom < 0);
          ticking = false;
        });
      }, { passive: true });
    }

    // Mantiene el offset sincronizado si el alto de la barra cambia
    // (variante más larga, idioma, ancho de pantalla) mientras está visible.
    if ('ResizeObserver' in window) {
      if (!kkStickyResizeObserver) {
        kkStickyResizeObserver = new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var el = entry.target;
            if (el.classList.contains('is-visible')) {
              setStickyOffset(el.offsetHeight);
            }
          });
        });
      }
      kkStickyResizeObserver.observe(bar);
    }

    var addBtn = bar.querySelector('[data-kk-sticky-add]');
    var variantSelect = bar.querySelector('[data-kk-sticky-variant]');

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        // Evita doble click / doble producto mientras hay una request en curso.
        if (addBtn.dataset.kkSubmitting === '1') return;

        var variantId = variantSelect && variantSelect.value;
        if (!variantId) return;

        // Reusa el MISMO formulario y botón que usa la ficha de producto,
        // para que el agregado al carrito, el redibujo del carrito lateral,
        // el subtotal, el contador y la barra de envío gratis se actualicen
        // exactamente igual que con el botón principal (sin recarga).
        var realForm = document.querySelector('form[action="/cart/add"]');
        var realIdInput = realForm && realForm.querySelector('[name="id"]');
        var realSubmitBtn = realForm && realForm.querySelector('[data-add-to-cart]');

        if (!realForm || !realIdInput || !realSubmitBtn) {
          // Fallback (no debería ocurrir en la página de producto): comportamiento anterior.
          setBtnLoading(addBtn, true);
          addToCart([{ id: variantId, quantity: 1 }])
            .then(function () { refreshCartUI(); })
            .catch(function () { alert('No se pudo agregar el producto. Intenta nuevamente.'); })
            .finally(function () { setBtnLoading(addBtn, false); });
          return;
        }

        addBtn.dataset.kkSubmitting = '1';
        setBtnLoading(addBtn, true);

        if (realIdInput.value !== variantId) {
          realIdInput.value = variantId;
          realIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var released = false;
        var release = function () {
          if (released) return;
          released = true;
          setBtnLoading(addBtn, false);
          addBtn.dataset.kkSubmitting = '';
        };

        // El botón real se deshabilita mientras el theme procesa el agregado;
        // cuando vuelve a habilitarse, liberamos el botón sticky.
        if ('MutationObserver' in window) {
          var mo = new MutationObserver(function () {
            if (!realSubmitBtn.disabled) {
              mo.disconnect();
              release();
            }
          });
          mo.observe(realSubmitBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
        }
        // Seguro máximo por si el theme no vuelve a habilitar el botón (p.ej. error de red).
        setTimeout(release, 6000);

        realSubmitBtn.click();
      });
    }

    onVariantChange(function (variantId, variant) {
      if (variantSelect) variantSelect.value = variantId;
      var priceEl = bar.querySelector('[data-kk-sticky-price]');
      if (priceEl && variant && variant.price != null) {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (addBtn) {
        var available = !variant || variant.available !== false;
        addBtn.disabled = !available;
      }
    });
  }

  function initSizeChart() {
    var trigger = document.querySelector('[data-kk-size-trigger]');
    var modal = document.querySelector('[data-kk-size-modal]');
    if (!trigger || !modal || trigger.dataset.kkInit === '1') return;
    trigger.dataset.kkInit = '1';

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', open);
    modal.querySelectorAll('[data-kk-size-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initScrollTop() {
    var btn = document.querySelector('[data-kk-scroll-top]');
    if (!btn || btn.dataset.kkInit === '1') return;
    btn.dataset.kkInit = '1';

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        btn.classList.toggle('is-visible', window.scrollY > 600);
        ticking = false;
      });
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}');
      }
    } catch (e) { /* noop */ }
    return (cents / 100).toFixed(0);
  }

  function onVariantChange(cb) {
    var handled = function (evt) {
      var variant = (evt.detail && (evt.detail.variant || evt.detail)) || null;
      var variantId = variant && (variant.id || variant.variant_id);
      if (variantId) cb(String(variantId), variant);
    };
    ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
      document.addEventListener(name, handled);
    });

    var mainForm = document.querySelector('form[action="/cart/add"]');
    if (mainForm) {
      mainForm.addEventListener('change', function () {
        var idInput = mainForm.querySelector('input[name="id"]');
        if (idInput && idInput.value) cb(idInput.value, null);
      });
    }
  }

  function boot() {
    initBogo();
    initBundle();
    initStockScarcity();
    initStickyAtc();
    initScrollTop();
    initSizeChart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
